var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticStyle:{"cursor":"pointer"},attrs:{"width":"3.125rem","src":require("@/assets/door-close.svg")},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }